export function mapRange(n, from, to) {
  return (n - from.min) * (to.max - to.min) / (from.max - from.min) + to.min;
}